// extracted by mini-css-extract-plugin
export default {"submit":"PasswordUpdateForm_submit__0WNCa","submitBtn":"PasswordUpdateForm_submitBtn__134rx"};